/*
 * Regroups all API calls related to the user that do not impact the state
 */

import { Preferences, User } from "@src/types/global";
import { api } from "@src/utils/axios-instance";
import { AxiosResponse } from "axios";

export async function requestPasswordReset(data: {
    email: string;
}): Promise<string> {
    const res = await api.post("/users/reset-password", data);
    return res.data;
}
export async function resetPassword({
    token,
    ...data
}: {
    token: string;
    password: string;
    confirm_password: string;
}): Promise<string> {
    const res = await api.post("/users/reset-password/" + token, data);
    return res.data;
}

export async function requestBetaAccess(email: string) {
    let res = await api.post("/api/v1/user/beta/request-invite", {
        email: JSON.stringify(email.toLowerCase()),
    });
    return res.data.success;
}

export async function register(data: {
    email: string;
    password: string;
    confirm_password: string;
    portfolio_link: string;
    terms_and_conditions: boolean;
    username?: string;
}): Promise<{ token: string; email: string; id: string }> {
    const res = await api.post("/users/register", {
        user: data,
    });
    return res.data;
}
export async function login(data: {
    email: string;
    password: string;
}): Promise<{ data: { token: string; email: string; id: string } }> {
    const res = await api.post("/users/log_in", data);
    return res;
}

export const fetchUserPreferences = async (): Promise<Preferences> => {
    const { data } = (await api.get("/users/settings")) as any;
    return data.data.preferences;
};
